import React from 'react';
import PropTypes from 'prop-types';

// Components
import Checkbox from '../../../Checkbox/Checkbox';

import s from './Profile.css';

// ContactInfoBasic is a stripped down version of ContactInfo
// for usage when a partner has feature flaged some functionality
const ContactInfoBasic = ({ optOut, updateValue }) =>
  <section className={s.component}>
    <h3 className={s.header}>
      Contact Information
    </h3>

    <div className={s.group}>
      <div className={s.controlContainer}>
        <Checkbox
          id="healthInfo"
          checked={!optOut}
          onChange={checked => updateValue("optOut", !checked)}
        >
          Send protected health information to my patient portal
        </Checkbox>
      </div>
    </div>
  </section>;

ContactInfoBasic.propTypes = {
  destinations: PropTypes.object,
  contactMethodOptions: PropTypes.array,
  labels: PropTypes.object,
  contactMethod: PropTypes.object,
  optOut: PropTypes.bool,
  updateValue: PropTypes.func,
};

export default ContactInfoBasic;



// WEBPACK FOOTER //
// ./src/components/Pages/Account/Profile/ContactInfoBasic.js